
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "90px",
    "height": "26px",
    "viewBox": "0 0.015 90 26",
    "enable-background": "new 0 0.015 90 26",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "y": "0.015",
        "fill": "none",
        "width": "90",
        "height": "26"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M69.684,23.104c-0.482,0-0.848-0.041-1.09-0.123c-0.262-0.09-0.535-0.299-0.816-0.624\r\n\t\t\t\t\tc-0.283-0.327-0.423-0.785-0.423-1.376V10.125c0-1.271-0.294-2.168-0.88-2.687c-0.514-0.438-1.346-0.656-2.496-0.656h-1.467\r\n\t\t\t\t\tv2.824h0.695c0.907,0,1.361,0.441,1.361,1.328v9.31l-0.012,0.01c0,0.896-0.352,1.487-0.806,1.874\r\n\t\t\t\t\tc-0.315,0.27-1.483,0.781-2.935,0.826c-1.727,0.056-2.498-0.441-2.858-0.84c-0.414-0.458-0.539-1.06-0.575-1.467V4.186\r\n\t\t\t\t\tc0-1.202-0.365-2.157-1.09-2.87c-0.736-0.734-1.669-1.1-2.799-1.1H41.373V2.98h3.465v8.489h-3.51v2.824h3.51v8.703h-6.309\r\n\t\t\t\t\tc-0.434,0-0.732-0.077-0.894-0.229c-0.132-0.131-0.196-0.396-0.196-0.795V9.729c0-0.92-0.248-1.614-0.741-2.094\r\n\t\t\t\t\tc-0.536-0.527-1.247-0.788-2.136-0.777H31.6v2.824h2.086c0.638,0,0.955,0.356,0.955,1.067v12.433\r\n\t\t\t\t\tc0,0.771,0.237,1.398,0.71,1.876c0.494,0.487,1.156,0.733,1.981,0.733h10.305V14.294h5.236V11.47h-5.236V2.98h5.357\r\n\t\t\t\t\tc0.403,0,0.781,0.173,1.135,0.52c0.304,0.294,0.453,0.868,0.453,1.725v15.649c0,0.799,0.11,1.494,0.329,2.098\r\n\t\t\t\t\tc0.26,0.781,0.763,1.562,1.744,2.105c2.325,1.287,5.856,0.852,5.856,0.852c0.804-0.096,1.423-0.164,1.936-0.396\r\n\t\t\t\t\tc0.443-0.203,0.953-0.564,1.528-1.084c0.535,0.5,1.034,0.85,1.499,1.053c0.654,0.285,1.496,0.428,2.527,0.428h20.411v-2.824\r\n\t\t\t\t\tH69.684z M37.818,0.154H31.6V2.98h6.219V0.154z M69.456,9.468l0.029,11.91h2.802v-3.557h5.96l0.017,3.557h2.813v-3.557h5.856\r\n\t\t\t\t\tc-0.161,0.641-0.808,0.961-1.938,0.961c-0.159,0-0.313-0.004-0.453-0.014v2.596c1.029-0.01,1.758-0.057,2.194-0.138\r\n\t\t\t\t\tc1.068-0.183,1.896-0.642,2.48-1.374c0.414-0.52,0.62-1.359,0.62-2.52V9.148c0-1.466-0.681-2.514-2.044-3.144\r\n\t\t\t\t\tc0.355-0.531,0.572-0.861,0.652-0.994c0.443-0.713,0.666-1.415,0.666-2.107c0-0.865-0.352-1.553-1.059-2.063\r\n\t\t\t\t\tc-0.727-0.527-1.711-0.795-2.951-0.795h-15.19v2.813l14.677,0.029c0.777,0,1.164,0.199,1.164,0.597\r\n\t\t\t\t\tc0,0.182-0.101,0.417-0.304,0.701c-0.149,0.203-0.569,0.754-1.255,1.649h-8.625c-0.411-0.59-0.761-1.181-1.044-1.773h-2.95\r\n\t\t\t\t\tc0.273,0.612,0.58,1.209,0.924,1.787c-0.969,0.193-1.654,0.49-2.058,0.889C69.783,7.368,69.456,8.277,69.456,9.468z\r\n\t\t\t\t\t M81.076,8.673l4.994-0.027c0.623,0,0.948,0.33,0.968,0.992l0.017,0.854h-5.979V8.673z M81.076,13.301h5.979v1.74h-5.979V13.301\r\n\t\t\t\t\tz M72.301,9.591c0.021-0.631,0.424-0.945,1.211-0.945l4.735,0.027v1.819h-5.96L72.301,9.591z M72.287,13.301h5.96v1.74h-5.96\r\n\t\t\t\t\tV13.301z M67.793,0h-5.237v2.98h5.237V0z"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M24.002,4.074h4.464V1.263h-4.464V4.074z M23.729,6.577h-2.041V0.071h-2.8v6.506h-2.573\r\n\t\t\tc-1.299,0-2.318,0.392-3.055,1.178c-0.715,0.762-1.075,2.004-1.075,3.724v11.649H7.252c-0.352,0-0.621-0.09-0.802-0.272\r\n\t\t\tc-0.161-0.163-0.241-0.489-0.241-0.978v-4.277h4.086v-2.825H6.209v-3.646h4.086V8.302H0.413v2.827h2.995v3.646H0.413v2.825h2.995\r\n\t\t\tv5.438c0,0.957,0.259,1.68,0.773,2.166c0.506,0.48,1.139,0.721,1.906,0.721h7.892V25.92h1.036v-4.685h10.562v0.305\r\n\t\t\tc0,0.348-0.136,0.662-0.409,0.947c-0.385,0.428-0.849,0.641-1.393,0.641h-1.709V26h1.847c1.331,0,2.439-0.464,3.327-1.391\r\n\t\t\tc0.758-0.793,1.134-2.03,1.134-3.71v-9.588c0-1.609-0.361-2.789-1.088-3.543C26.509,6.974,25.324,6.577,23.729,6.577z\r\n\t\t\t M25.577,18.411H15.016v-3.068h10.562V18.411z M25.577,12.503H15.016v-1.499c0-0.518,0.162-0.919,0.484-1.204\r\n\t\t\tc0.273-0.236,0.59-0.352,0.953-0.352h7.611c0.483,0,0.85,0.139,1.104,0.412c0.273,0.283,0.409,0.596,0.409,0.932V12.503z\r\n\t\t\t M16.226,1.263h-4.419v2.812h4.419V1.263z M4.424,4.653h5.871V1.829H5.271l0.453-1.572H2.729C2.628,0.581,2.451,1.172,2.197,2.028\r\n\t\t\tc-0.29,1.027-0.543,1.658-0.754,1.893c-0.242,0.274-0.585,0.458-1.03,0.55v2.87c1.081-0.172,1.878-0.418,2.392-0.732\r\n\t\t\tC3.38,6.242,3.919,5.591,4.424,4.653z"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "_x3C_切片_x3E__1_",
        "y": "0.015",
        "fill": "none",
        "width": "90",
        "height": "26"
      }
    }
  ]
})
    }
  